import React, { useState } from 'react';
import styles from './ImageList.module.css';
import { AddBtnSvg } from '../../SVGComponents/SVGComponents';
import AddFilePopup from '../AddFilePopup/AddFilePopup';
import { useDispatch, useSelector } from 'react-redux';
import { deleteDocBd, deleteFile } from '../../firebase';
import LoaderPage from '../LoaderPage/LoaderPage';
import { deleteItemFromArrayRedux } from '../../store/slices/filesSlice';
import { getReadableFileSize } from '../../helper';

const ImageList = () => {
  const allFiles = useSelector((state) => state.files.files);
  const images = (allFiles || []).filter((file) => file.fileType === 'image');
  const dispatch = useDispatch();

  const [activeImage, setActiveImaeg] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [loaderPage, setLoaderPage] = useState(false);

  const totalSize = images.reduce((sum, img) => sum + img.size.size, 0);
  const totalSizeObject = getReadableFileSize(totalSize);

  const deleteImage = async (image) => {
    let isRemove = window.confirm('Видалити зображення?');
    if (isRemove) {
      setLoaderPage(true);
      const isDeleteFile = await deleteFile(image.url);

      if (isDeleteFile) {
        const isDeleteDoc = await deleteDocBd('files', image.id);

        if (isDeleteDoc) {
          dispatch(deleteItemFromArrayRedux({ field: 'files', id: image.id }));
        } else {
          alert('Не вдалося видалити документ!!!');
        }
      } else {
        alert('Не вдалося видалити відео!!!');
      }
      setLoaderPage(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header_list}>
        <h3 className={styles.title}>Зображення для меню</h3>
        <button className={styles.addImage_btn} onClick={() => setShowPopup(true)}>
          <AddBtnSvg />
        </button>
      </div>
      {images.map((image) => (
        <div
          className={image.newFile ? styles.item + ' ' + styles.item_new : styles.item}
          key={image.id}>
          <div className={styles.header}>
            <h3 className={styles.title}>{image.title}</h3>
            <span className={styles.size}>
              {image.size.value}&nbsp;{image.size.label}
            </span>
          </div>

          <p className={styles.description}>{image.description}</p>

          <div className={styles.buttons}>
            <button className={styles.playButton} onClick={() => setActiveImaeg(image.url)}>
              Переглянути
            </button>

            <button className={styles.deleteButton} onClick={() => deleteImage(image)}>
              Видалити
            </button>
          </div>
        </div>
      ))}

      {/* POPUP */}
      {showPopup && <AddFilePopup onClose={() => setShowPopup(false)} fileType="image" />}
      {/* POPUP */}
      {activeImage && (
        <div className={styles.popupOverlay} onClick={() => setActiveImaeg(null)}>
          <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
            <img src={activeImage} alt="preview" controls className={styles.image} />

            <button className={styles.closeBtn} onClick={() => setActiveImaeg(null)}>
              ✕
            </button>
          </div>
        </div>
      )}
      <div className={styles.foter_list}>
        <h3 className={styles.title}>Обший ромір</h3>
        <span className={styles.size}>
          {totalSizeObject.value}&nbsp;{totalSizeObject.label}
        </span>
      </div>

      {loaderPage ? <LoaderPage /> : ''}
    </div>
  );
};

export default ImageList;
